import { render, staticRenderFns } from "./_NavItems.vue?vue&type=template&id=743b3c12"
import script from "./_NavItems.vue?vue&type=script&lang=js"
export * from "./_NavItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports